import { Component } from '@angular/core'

@Component({
  selector: 'app-digital-specialist',
  templateUrl: './ai-reconciler-page.component.html',
  styleUrls: [`./ai-reconciler-page.component.scss`],
})
export class AiReconcilerPageComponent {}
